import { Box, Flex, Text, Badge, Spinner, SimpleGrid } from '@chakra-ui/react';
import Card from 'components/card/Card';
import Pagination, { usePaged } from 'components/vdh/Pagination';
import { api } from 'lib/api';
import { useApi } from 'lib/useApi';
import BattleCard from 'components/vdh/BattleCard';
import PartyCard from 'components/vdh/PartyCard';

/** Theo dõi thách đấu: Đại Chiến Gia Đình (2-4 người) ở trên, trận 1v1 ở dưới. */
export default function Battles() {
  const { data, loading, error } = useApi(() =>
    Promise.all([
      api.get('/battles'),
      api.get('/battles/party'),
      api.get('/battles/party/history'),
    ]).then(([duel, partyLive, partyDone]) => ({ duel, partyLive, partyDone })));

  if (loading) return <Box pt={{ base: '130px', md: '80px' }}><Spinner /></Box>;
  if (error) return <Box pt={{ base: '130px', md: '80px' }}><Text color="red.500">{error}</Text></Box>;

  const { duel, partyLive, partyDone } = data;
  if (!duel.length && !partyLive.length && !partyDone.length) {
    return <Box pt={{ base: '130px', md: '80px' }}><Card><Text>Chưa có trận thách đấu nào.</Text></Card></Box>;
  }

  const live = duel.filter((b) => b.status === 'active');
  const waiting = duel.filter((b) => b.status === 'open');
  const history = duel
    .filter((b) => b.status === 'done' || b.status === 'cancelled')
    .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
  const partyRunning = partyLive.filter((r) => r.status === 'active');
  const partyWaiting = partyLive.filter((r) => r.status === 'open');

  return (
    <Box pt={{ base: '130px', md: '80px', xl: '80px' }}>
      <Section title="⚔️ Đại Chiến đang đấu" scheme="orange" list={partyRunning} render={(r) => <PartyCard r={r} />} />
      <Section title="🚪 Phòng Đại Chiến đang chờ" scheme="teal" list={partyWaiting} render={(r) => <PartyCard r={r} />} />
      <Section title="🔴 1v1 đang diễn ra" scheme="red" list={live} render={(b) => <BattleCard b={b} />} />
      <Section title="⏳ 1v1 phòng chờ" scheme="blue" list={waiting} render={(b) => <BattleCard b={b} />} />
      <Section title="📜 Lịch sử Đại Chiến" scheme="purple" list={partyDone} pageSize={9} render={(r) => <PartyCard r={r} />} />
      <Section title="📜 Lịch sử 1v1" scheme="gray" list={history} pageSize={9} render={(b) => <BattleCard b={b} />} />
    </Box>
  );
}

function Section({ title, scheme, list, render, pageSize = 12 }) {
  const pager = usePaged(list, pageSize);
  if (!list.length) return null;
  return (
    <>
      <Flex align="center" gap="9px" mb="12px">
        <Text fontWeight="850" fontSize="16px">{title}</Text>
        <Badge colorScheme={scheme} borderRadius="99px">{list.length} trận</Badge>
      </Flex>
      <SimpleGrid columns={{ base: 1, md: 2, xl: 3 }} gap="16px">
        {pager.pageItems.map((it) => <Box key={it.id}>{render(it)}</Box>)}
      </SimpleGrid>
      <Box mb="24px"><Pagination pager={pager} label="trận" /></Box>
    </>
  );
}
